<template>
  <el-dialog :visible.sync="visible"
             title="编辑">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" label-width="120px">
      <el-form-item prop="name" label="姓名">
        <el-input v-model="dataForm.name" placeholder="姓名" disabled :maxlength="20"></el-input>
      </el-form-item>
      <el-form-item prop="postId" label="岗位">
        <el-select v-model="dataForm.postId"
                   placeholder="请选择"
                   filterable
                   remote
                   :remote-method="searchPostList"
                   :loading="loading">
          <el-option
            v-for="item in postList"
            :key="item.postId"
            :label="item.postName"
            :value="item.postId">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="dataFormSubmitHandle()">确 定</el-button>
      <el-button @click="visible = false">取消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      orgTree: [],
      dataForm: {
        custId: '',
        name: '',
        postId: ''
      },
      postList: [],
      loading: false
    }
  },
  computed: {
    dataRule () {
      return {
        name: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        postId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        this.dataForm.name = ''
        this.dataForm.postId = ''
        this.postList = []
        if (this.dataForm.custId) {
          this.getInfo()
        }
      })
    },
    getInfo () {
      this.$request.get(`/front/consumer/custorg/sysUserInfo/${this.dataForm.custId}`)
        .then((res) => {
          this.dataForm.name = res.name
          this.dataForm.postId = res.postId
          if (res.postId) {
            this.postList = [{
              postName: res.postName,
              postId: res.postId
            }]
          } else {
            this.postList = []
          }
          this.searchPostList('')
        }).catch(() => {})
    },
    searchPostList (query) {
      // if (query !== '') {
      this.loading = true
      setTimeout(() => {
        this.loading = false
        this.$http.get(`/front/consumer/custorg/custPostlist`,
          {
            params: {
              postName: query || '',
              companyId: this.$store.state.user.defaultCompanyId
            }
          }
        ).then(({ data: res }) => {
          if (res.code !== 0) {
            this.postList = []
            return false // this.$message.error(res.message)
          }
          this.postList = res.data || []
        }).catch(() => {
        })
      }, 200)
      // } else {
      //   this.postList = []
      // }
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http.post(`/front/consumer/custorg/setCustPost`, this.dataForm)
          .then(({ data: res }) => {
            if (res.code !== 0) {
              return false
              // this.$message.error(res.msg)
            }
            this.$message({
              message: this.$t('prompt.success'),
              type: 'success',
              duration: 500,
              onClose: () => {
                this.visible = false
                this.$emit('refreshDataList')
              }
            })
          }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
<style lang='scss' scoped>
</style>
